module.exports = __webpack_public_path__ + "static/media/状态进度.319da655.svg";